<script lang="ts">
    
    import { createEventDispatcher } from 'svelte';
    import { fly } from 'svelte/transition';
    import IconChevron from './IconChevron.svelte';

    export let title: string = '';
    export let flex = false;

    const dispatch = createEventDispatcher();

    function onClose(): void {
        dispatch('close');
    }

</script>

<div class="activity-modal" transition:fly={{ x: 100 }}>
    <div class="header">
        <button type="button" class="close-btn" on:click={onClose}>
            <IconChevron />
        </button>
        <div class="title">{title}</div>
    </div>
    <div class="content" class:flex>
        <slot />
    </div>
</div>

<style lang="scss">

    .activity-modal {
        position: fixed;
        z-index: 50;
        top: 0;
        left: 0;
        width: 100vw;
        height: var(--vh, 100vh);
        touch-action: auto;
        pointer-events: auto;
        background-color: #fff;
        display: flex;
        flex-direction: column;
    }

    .header {
        height: 60px;
        display: flex;
    }

    .close-btn {
        width: 60px;
        height: 60px;
        border: none;
        background-color: transparent;
    }

    .title {
        width: calc(100% - 120px);
        display: flex;
        justify-content: center;
        align-items: center;
        color: #000;
        font-size: 1.2rem;
    }

    .content {
        flex: 1 1 0;
        overflow: auto;

        &.flex {
            display: flex;
            flex-direction: column;
        }
    }

</style>
